export default __webpack_public_path__ + "static/media/image.d5486ab1.svg";